<template>
  <div>
    <div class="moduleWrapper">
      <!-- POC Script section -->
      <div
        class="codeWrapper"
        v-if="vul.pocScript"
      >
        <h3 style="margin-bottom: 8px">{{ $t('vulnerabilityInformation.proofOfConcept') }}</h3>
        <div class="codeTitle">
          <h3>Python</h3>
          <img
            src="@assets/codeScan/code_scan_fff.png"
            @click="copyOxpeckerIp(vul.pocScript)"
          />
        </div>
        <CodeMirror
          :value="vul.pocScript"
          :options="{
                mode: 'text/x-python',
                theme: 'base16-dark',
                lineNumbers: true,
                line: true,
                readOnly: true,
              }"
        />
      </div>
      <!-- POC Output section -->
      <div
        class="codeWrapper"
        v-if="vul.pocScriptOutput"
      >
        <h3 style="margin-bottom: 8px">{{ $t('vulnerabilityInformation.proofExecutionResult') }}</h3>
        <CodeMirror
          :value="vul.pocScriptOutput"
          :options="{
                mode: 'text',
                theme: 'base16-dark',
                lineNumbers: true,
                line: true,
                readOnly: true,
              }"
        />
        <div
          class="images"
          v-if="images && images.length"
        >
          <div
            class="image-item"
            v-for="image in images"
            :key="image"
          >
            <el-image
              :src="image"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { codemirror } from 'vue-codemirror';
import 'codemirror/lib/codemirror.css';
import { copyText } from '@/utils/copy-text';
import { LANGUAGE_TYPES } from '@/enum';

require('codemirror/mode/python/python');
require('codemirror/mode/clike/clike');
require('codemirror/theme/base16-dark.css');

export default {
  name: 'SinkVul',
  components: {
    CodeMirror: codemirror,
  },
  props: {
    language: {
      type: String,
      default: LANGUAGE_TYPES.JAVA,
    },
    sinkInfo: {
      type: Object,
      default: () => ({}),
    },
    sourceInfo: {
      type: Object,
      default: () => ({}),
    },
    vul: {
      type: Object,
      default: () => ({}),
    },
    images: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    localLanguage() {
      const { language } = this;
      const languageMap = {
        [LANGUAGE_TYPES.JAVA]: 'Java',
        [LANGUAGE_TYPES.JAVASCRIPT]: 'JavaScript',
      };

      return languageMap[language] || 'Java';
    },
  },
  methods: {
    objectSpanMethod({ rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % 4 === 0) {
          return {
            rowspan: 4,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    copyOxpeckerIp(code) {
      copyText(code);
    },
  },
};
</script>
